




























import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import DataSource from 'devextreme/data/data_source';
import DxSelectBox from 'devextreme-vue/ui/select-box';
import {DxTextBox} from 'devextreme-vue/ui/text-box';
import {DxDateBox} from 'devextreme-vue/ui/date-box';

import {Notification} from '@/services/data/notification';
import base_ds from '@/services/base_datasource_service';
import request from '@/utils/request';
import {formatDateTimeAsLocal, isoDateTimeWithoutTZ} from '@/utils/datetime';
import {numeralForm} from '@/utils/numbers';
import DEditPopup from '@/components/DEditPopup/editpopup.vue';
import TableGrid from '@/components/TableGrid/grid.vue';
import DButton from '@/components/DButton/button.vue';

function filterDateTimeConverter(filterExpression: Array<string>): string {
  if (filterExpression.length === 3) {
    if (filterExpression[0] === 'notif_time') {
      return isoDateTimeWithoutTZ(new Date(filterExpression[2]));
    } else {
      return filterExpression[2];
    }
  }
  return '';
}

@Component({
  name: 'UserLogsPopup',
  components: {
    DEditPopup,
    TableGrid,
    DButton,
    DxSelectBox,
    DxTextBox,
    DxDateBox
  }
})
export default class extends Vue {
  @Prop({default: false}) visible!: boolean;
  @Prop() user!: any;

  private columns: any[] = [];

  public dataSource: any = [];
  private url_route = 'admin/user/logs';


  @Emit('close')
  private onClose() {
  }


  private mounted() {

    this.columns = [
      {
        dataField: 'id',
        dataType: 'string',
        visible: false
      },
      {
        dataField: 'user_id',
        dataType: 'string',
        visible: false
      },
      {
        dataField: 'date_created',
        dataType: 'datetime',
   
        allowFiltering: false,
 
        caption: 'Время события',
        cssClass: 'time',
        sortOrder: 'desc'
      },
      {
        dataField: 'activity_type',
        dataType: 'string',

        caption: 'Тип действия',
      },
      {
        dataField: 'activity_info',
        dataType: 'string',

        caption: 'Информация по действию',
      },

      {
        dataField: 'activity_ip',
        dataType: 'string',

        caption: 'Адрес доступа',
      },
    ];
  }

  public get userName() {
    return this.user && this.user.full_name ? this.user.full_name : '';
  }
  private onShow() {

    this.dataSource = base_ds.getBaseDataSource(
      `${this.url_route}/${this.user.id}`,
      'id',

    );
    this.dataSource.reload();
  }


  private formatUTCTime(e: any): string {
    return formatDateTimeAsLocal(e.value);
  }
}
